import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import MainForm from "./EmploymentForm/MainForm";
import { useDispatch, useSelector } from "react-redux";
import Footer from './Footer.js';
import StepCount from "./Common/StepCount";
import {
  getEmployment,
  saveEmploymentAnswer,
  deleteEmploymentAnswer,
} from "../Actions/employmentActions";
import { useParams } from "react-router-dom";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import QuestionForm from "../components/EmploymentForm/QuestionForm";
import {
  fresherOptions,
  employmentCountOptions,
} from "./EmploymentForm/empConstants";
import Loader from "./Common/loaderOnlySpinner";
import GetMasterData from "../Helper/masterData";
import { useNavigate } from "react-router-dom";
import CalendarIcon from '../assets/img/calendar-icon.svg';
import TickIconBlack from '../assets/img/tick-icon-black.png';
import CrossIcon from '../assets/img/cross-icon.png';
import CallIcon from '../assets/img/call-icon.png';
import EmailIcon from '../assets/img/email-icon.png';
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import ProgressHeading from "./Common/ProgressHeading.jsx";

const CandidateIndianPoliceRecord = () => {
  let { activeTab, reference } = useParams();

  //Handling Form Reference
  const [role,setRole]=useState();
  const form = useRef();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    pinCode: null,
    city: null,
    state: null,
    policeStation: null,
    residingFrom: null,
    residingTill: null,
    documentType: null,
    referenceName1: null,
    relationWithReference1: null,
    email1: null,
    mobile1: null,
    referenceName2: null,
    relationWithReference2: null,
    email2: null,
    mobile2: null,
  });


  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  return (
    <>
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Employment Details"} />
            </div>
            <div className="col bg-gray-mbl">
          
              {/*Form*/}

              <form
                className="p-3 form2 form-section"
                style={{ minHeight: "700px" }}
              >
                <StepCount activeTab={"Employment Details"}/>
                <div className="d-flex justify-content-between align-items-center">
               
                  <div>
                    <h2 className="fnt-smi-bld">Indian Police Record Details</h2>
                    <p className="text-muted mb-0">Please add your details for verification process.</p>
                  </div>
                  <button className="btn btn-primary">+ Add Address</button>
                </div>
                <hr />
                <h6 className="fnt-smi-bld">Note : Please enter details with your current address, If its alreday there, please ignore</h6>
                <p className="text-muted">Period of stay in  address given addresss must be over 6 months.</p>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="pinCode" id="pinCode" onChange={handleFloatingLabels} />
                        <label htmlFor="pinCode" className={formData.pinCode && 'focused'}>Pincode<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="city" id="city" onChange={handleFloatingLabels} />
                        <label htmlFor="city" className={formData.city && 'focused'}>City<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="state" id="state" onChange={handleFloatingLabels} />
                        <label htmlFor="state" className={formData.state && 'focused'}>State<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="policeStation" id="policeStation" onChange={handleFloatingLabels} />
                        <label htmlFor="policeStation" className={formData.policeStation && 'focused'}>Police Station<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={CalendarIcon} alt="" />
                        <input type="text" className="form-control" name="residingFrom" id="residingFrom" onChange={handleFloatingLabels} />
                        <label htmlFor="residingFrom" className={formData.residingFrom && 'focused'}>Residing from<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={CalendarIcon} alt="" />
                        <input type="text" className="form-control" name="residingTill" id="residingTill" onChange={handleFloatingLabels} />
                        <label htmlFor="residingTill" className={formData.residingTill && 'focused'}>Residing till<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="form-check mt-3">
                        <input type="checkbox" className="form-check-input" name="workingTillNow" id="workingTillNow" />
                        <label htmlFor="workingTillNow" className="form-check-label">Working till now</label>
                      </div>
                    </div>
                  </div>
                </div>

                <button className="btn btn-primary btn-lg">
                  Update
                </button>
                <h6 className="fnt-smi-bld mb-0 mt-3">Upload Address Proof</h6>

                <small className="text-muted">upload your related documents</small>

                <div className="row mt-3">
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <select name="documentType" id="documentType" className="form-control" onChange={handleFloatingLabels} >
                          <option value=""></option>
                          <option value="d">d</option>
                        </select>
                        <label htmlFor="documentType" className={formData.documentType && 'focused'}>Select Document Type</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="upload-box">
                      <div className="left d-flex align-items-center">
                        <img src={TickIconBlack} className="mr-2 pl-3 pr-3" alt="" />
                        <span>
                          <h6 className="m-0">Salary slip uploaded</h6>
                          <small className="text-muted">6 Files uploaded</small>
                        </span>
                      </div>
                      <div className="right text-right">
                        <img src={CrossIcon} alt="" className="remove-btn" />
                      </div>
                    </div>
                  </div>
                </div>

                <h6 className="fnt-smi-bld mt-3">Reference 1</h6>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="referenceName1" id="referenceName1" onChange={handleFloatingLabels} />
                        <label htmlFor="referenceName1" className={formData.referenceName1 && 'focused'}>Reference Name</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="relationWithReference1" id="relationWithReference1" onChange={handleFloatingLabels} />
                        <label htmlFor="relationWithReference1" className={formData.relationWithReference1 && 'focused'}>Relationship with Reference</label>
                      </div>
                    </div>
                  </div>
                </div>

                <h6 className="fnt-smi-bld mt-3">Reference 2</h6>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="referenceName2" id="referenceName2" onChange={handleFloatingLabels} />
                        <label htmlFor="referenceName2" className={formData.referenceName2 && 'focused'}>Reference Name</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="relationWithReference2" id="relationWithReference2" onChange={handleFloatingLabels} />
                        <label htmlFor="relationWithReference2" className={formData.relationWithReference2 && 'focused'}>Relationship with Reference</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={EmailIcon} />
                        <input type="text" className="form-control" name="email2" id="email2" onChange={handleFloatingLabels} />
                        <label htmlFor="email2" className={formData.email2 && 'focused'}>Email Address</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={CallIcon} />
                        <input type="text" className="form-control" name="mobile2" id="mobile2" onChange={handleFloatingLabels} />
                        <label htmlFor="mobile2" className={formData.mobile2 && 'focused'}>Mobile Number</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">Back</button>
                    <button className="btn btn-primary btn-lg btn-block mt-3">Save</button>
                  </div>
                </div>

              </form>

              {/*Form*/}
              <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">
                      Submit for Preview
                    </button>
                    <span className="text-muted">
                      Please complete the all mandatory fields before final
                      submission
                    </span>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default CandidateIndianPoliceRecord;
